import { forwardRef, useEffect, useState } from "react";
import { LayersControl, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import mapDepot from "../../../../../assets/images/map-depot.svg";
import { CommonConst as Consts } from "../../../../../shared/common-utilities/enums/CommonConst.jsx";
import dataStorageService from "../../../../../shared/common-utilities/services/DataStorageService";
import getSetDataService from "../../../../../shared/common-utilities/services/getSetDataService";

let service = getSetDataService();
let storageService = dataStorageService();
const userData = JSON.parse(storageService.getLocalStorageData('userData'))
const defaultOverlayLayers = service.defaultOverlayLayers;

const LayersComponent = forwardRef(({ sendDataToParent }) => {
    const map = useMap();
    const [currSelection, setCurrSelection] = useState('image-tiles')
    const streetUrl = `${process.env.REACT_APP_PTV_URL}${process.env.REACT_APP_PTV_MAP_TYPE}/v1/image-tiles/{x}/{y}?apiKey=${userData?.ptvDeveloperToken}&layers=${process.env.REACT_APP_DEFAULT_LAYERS}`
    // 'https://api.myptv.com/rastermaps/v1/image-tiles/{z}/{x}/{y}?apiKey=RVVfMTUyZjE2NGQxZmQyNGQyMmExNDRlM2U2NjQxZjNjNTA6NWI0ZGU2MTMtZTZlOC00NDA4LTg0OWItZWM2MjdlNGEwZDQy&layers=background,labels,transport,' //&style=amber
    const sateliteUrl = `${process.env.REACT_APP_PTV_URL}${process.env.REACT_APP_PTV_MAP_TYPE}/v1/satellite-tiles/{z}/{x}/{y}?apiKey=${userData?.ptvDeveloperToken}`
    // 'https://api.myptv.com/rastermaps/v1/satellite-tiles/{z}/{x}/{y}?apiKey=RVVfMTUyZjE2NGQxZmQyNGQyMmExNDRlM2U2NjQxZjNjNTA6NWI0ZGU2MTMtZTZlOC00NDA4LTg0OWItZWM2MjdlNGEwZDQy';

    const [baseLayers, setBaseLayers] = useState([
        {
            name: 'Streets',
            url: streetUrl,
            id: 'mapbox/streets-v11',
            maxZoom: 20,
            tileSize: 256,
            zoomOffset: -1,
            checked: true
        },
        {
            name: 'Satellite',
            url: sateliteUrl,
            maxZoom: 20,
            tileSize: 512,
            zoomOffset: -1,
            checked: false
        }
    ])
    const [overlayLayers, setOverlayLayers] = useState(defaultOverlayLayers)

    useEffect(() => {
        map.off("baselayerchange");
        map.off("overlayadd");
        map.off("overlayremove");

        map.on("baselayerchange", (e) => {
            setCurrSelection(e?.name == 'Streets' ? 'image-tiles' : 'satellite-tiles');
            if(e?.name == 'Streets'){
                setOverlayLayers(defaultOverlayLayers);
            } else {
                const filterdLayers = defaultOverlayLayers.filter(x=> x.for == 'Satellite' )
                setOverlayLayers(filterdLayers);
            }
        });
        map.on("overlayadd", (e) => {
            console.log("overlayadd");
            console.log(currSelection);
            if (e.name == "Backgroud") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?._url?.includes(currSelection))
                layers.forEach(element => {
                    let value = element._url.split('layers=');
                    if (value?.[1]) {
                        value[1] = 'background,' + value[1];
                    }
                    element.setUrl(value[0] + 'layers=' + value[1])
                });
            } else if (e.name == "Partial Trips") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?.options?.item?.source == Consts.PartialTrips)
                layers.forEach(element => {
                    element?.setOpacity && element?.setOpacity(1);
                });
            } else if (e.name == "Movements") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?.options?.item?.source == Consts.Movements)
                layers.forEach(element => {
                    element?.setOpacity && element?.setOpacity(1);
                });
            } else if (e.name == "Route") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?.options?.item?.source && x?._latlngs)
                layers.forEach(element => {
                    element?.setStyle && element?.setStyle({ opacity: 1 });
                });
            } else if (e.name == "Cluster") {
                sendDataToParent('setClustered(true)')
            } else if (e.name == "Labels") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?._url?.includes(currSelection))
                layers.forEach(element => {
                    let value = element._url.split('layers=');
                    if (value?.[1]) {
                        value[1] = 'labels,' + value[1];
                    }
                    element.setUrl(value[0] + 'layers=' + value[1])
                });
            } else if (e.name == "Toll") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?._url?.includes(currSelection))
                layers.forEach(element => {
                    let value = element._url.split('layers=');
                    if (value?.[1]) {
                        value[1] = 'toll,' + value[1];
                    }
                    element.setUrl(value[0] + 'layers=' + value[1])
                });
            } else if (e.name == "Traffic") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?._url?.includes(currSelection))
                layers.forEach(element => {
                    let value = element._url.split('layers=');
                    if (value?.[1]) {
                        value[1] = 'trafficPatterns,' + value[1];
                    }
                    element.setUrl(value[0] + 'layers=' + value[1])
                });
            } else if (e.name == "LEZ") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?._url?.includes(currSelection))
                layers.forEach(element => {
                    let value = element._url.split('layers=');
                    if (value?.[1]) {
                        value[1] = 'lowEmissionZones,' + value[1];
                    }
                    element.setUrl(value[0] + 'layers=' + value[1])
                });
            }
            
        });
        map.on("overlayremove", (e) => {
            console.log("overlayremove");
            if (e.name == "Backgroud") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?._url?.includes(currSelection))
                layers.forEach(element => {
                    let value = element._url.split('layers=');
                    if (value?.[1]) {
                        value[1] = value?.[1].replaceAll('background,', '');
                    }
                    element.setUrl(value[0] + 'layers=' + value[1])
                });
            } else if (e.name == "Partial Trips") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?.options?.item?.source == Consts.PartialTrips)
                layers.forEach(element => {
                    element?.setOpacity && element?.setOpacity(0);
                });
            } else if (e.name == "Movements") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?.options?.item?.source == Consts.Movements)
                layers.forEach(element => {
                    element?.setOpacity && element?.setOpacity(0);
                });
            } else if (e.name == "Route") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?.options?.item?.source && x?._latlngs)
                layers.forEach(element => {
                    element?.setStyle && element?.setStyle({ opacity: 0 });
                });
            } else if (e.name == "Cluster") {
                sendDataToParent('setClustered(false)')
            } else if (e.name == "Labels") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?._url?.includes(currSelection))
                layers.forEach(element => {
                    let value = element._url.split('layers=');
                    if (value?.[1]) {
                        value[1] = value?.[1].replaceAll('labels,', '');
                    }
                    element.setUrl(value[0] + 'layers=' + value[1])
                });
            } else if (e.name == "Toll") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?._url?.includes(currSelection))
                layers.forEach(element => {
                    let value = element._url.split('layers=');
                    if (value?.[1]) {
                        value[1] = value?.[1].replaceAll('toll,', '');
                    }
                    element.setUrl(value[0] + 'layers=' + value[1])
                });
            } else if (e.name == "Traffic") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?._url?.includes(currSelection))
                layers.forEach(element => {
                    let value = element._url.split('layers=');
                    if (value?.[1]) {
                        value[1] = value?.[1].replaceAll('trafficPatterns,', '');
                    }
                    element.setUrl(value[0] + 'layers=' + value[1])
                });
            }else if (e.name == "LEZ") {
                let layers = _.entries(map._layers)?.map(p => p[1])?.filter(x => x?._url?.includes(currSelection))
                layers.forEach(element => {
                    let value = element._url.split('layers=');
                    if (value?.[1]) {
                        value[1] = value?.[1].replaceAll('lowEmissionZones,', '');
                    }
                    element.setUrl(value[0] + 'layers=' + value[1])
                });
            }
        });
    }, [map, currSelection]);

    return (
        <LayersControl position="bottomright" >
            {baseLayers.map((layer, index) => (
                <LayersControl.BaseLayer key={index} name={layer.name} checked={layer.checked}>
                    <TileLayer
                        url={layer.url}
                        id={layer.id}
                        maxZoom={layer.maxZoom}
                        tileSize={layer.tileSize}
                        zoomOffset={layer.zoomOffset}
                    />
                </LayersControl.BaseLayer>
            ))}
            {overlayLayers.map((layer, index) => (
                <LayersControl.Overlay key={index} name={layer.name} checked={layer.checked}>
                    <Marker position={[0, 0]} icon={service.createCustomIcon(mapDepot, 8)} opacity={0}>
                        {layer.popup && (
                            <Popup>
                                {layer.popup}
                            </Popup>
                        )}
                    </Marker>
                </LayersControl.Overlay>
            ))}
        </LayersControl>
    );
});

export default LayersComponent;